import { useApiPost } from "../../../../lib/api";

type AuthTokenInput = {
  provider: string;
  code: string;
  token?: string;
  expires_at?: string;
  refresh_token?: string;
  profile_id?: string;
};

type AuthTokenResponse = {
  auth_token: {
    id: string;
    provider: string;
    code: string;
    expires_at: string | null;
    refresh_token: string | null;
    token: string;
  };
};

export const useCreateAuthToken = (callback: (token: AuthTokenInput) => void) => {
  const { mutate, isPending } = useApiPost<AuthTokenResponse, AuthTokenInput>(
    "/api/v1/auth/tokens",
    {
      onSuccess: (res) => {
        callback(res.auth_token as unknown as AuthTokenInput);
      },
      onError: (err) => {
        console.error(err);
      },
    }
  );

  const handleCreateAuthToken = (input: AuthTokenInput) => {
    mutate(input);
  };

  return [handleCreateAuthToken, isPending] as const;
};
